import { render, staticRenderFns } from "./InsurerForm.vue?vue&type=template&id=345bb0cb&scoped=true"
import script from "./InsurerForm.vue?vue&type=script&lang=ts"
export * from "./InsurerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345bb0cb",
  null
  
)

export default component.exports